import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import IconButton from '../common/IconButton.vue';
import {useBasicStore} from '../../../stores/basic';
import {storeToRefs} from 'pinia';
import {ICON_NAME} from '../../../constants/icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'Vote',
  setup(__props) {

const basicStore = useBasicStore();
const {showVoteDialog} = storeToRefs(basicStore);

const iconName = computed(() => (showVoteDialog.value ? ICON_NAME.voteActive : ICON_NAME.Vote));

function handleShowVotwDialog() {
  console.log(basicStore.showVoteDialog);
  basicStore.setShowVoteDialog(!basicStore.showVoteDialog);
}

return { __sfc: true,basicStore, showVoteDialog, iconName, handleShowVotwDialog, IconButton }
}

})